import React from "react";
import { callApi } from "../../utils/api";
import { Sro } from "./ManageSro";
import { ToastsStore } from "react-toasts";

declare var $: any;

interface AllProps {
  selectedSro: Sro;
  listSro: any;
  path?: any;
}
class AddSro extends React.Component<AllProps> {
  state = {
    srodetail: { sro_id: 0, sro: "" },
    isLoading: false
  };
  componentWillReceiveProps(nextState) {
    if (nextState.path == "managementsro") {
      const srodetail = nextState.selectedSro;
      srodetail.sro = srodetail.name;
      srodetail.sro_id = srodetail.id;
      delete srodetail.name;
      this.setState({ srodetail });
    }
  }
  handleChange = (e: any) => {
    const srodetail: any = this.state.srodetail;
    srodetail[e.target.name] = e.target.value;
    this.setState({ srodetail });
  };
  handleSaveResponse = (response: any) => {
    if (
      response.result === false ||
      (response.message && response.message.indexOf("Already Exist") !== -1)
    ) {
      ToastsStore.error(response.message || "Failed to save SRO");
      return;
    }
    this.props.listSro();
    $("#sro-form").modal("hide");
    ToastsStore.success(response.message || "SRO saved successfully");
  };
  saveSro = () => {
    const srodetail = { ...this.state.srodetail };
    srodetail.sro = srodetail.sro ? srodetail.sro.trim() : "";
    if (!srodetail.sro) {
      ToastsStore.error("SRO name is required");
      return;
    }
    if (srodetail.sro_id) {
      srodetail.sro_id = Number(srodetail.sro_id);
    }
    this.setState({ isLoading: true, srodetail });
    callApi("POST", "sro.php", srodetail)
      .then(res => res.data)
      .then(response => {
        this.handleSaveResponse(response);
      })
      .catch(err => {
        console.log(err);
        ToastsStore.error("Something went wrong, please try again");
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };
  render() {
    return (
      <div
        className="modal fade"
        id="sro-form"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">SRO Form</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="form-group">
                  <label className="col-form-label">SRO Name:</label>{" "}
                  <input
                    type="text"
                    name="sro"
                    className="form-control"
                    placeholder="Sro Name"
                    onChange={e => {
                      this.handleChange(e);
                    }}
                    value={
                      this.state.srodetail.sro ? this.state.srodetail.sro : ""
                    }
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                disabled={this.state.isLoading}
                onClick={this.saveSro}
              >
                {this.state.isLoading ? (
                  <i className="fa fa-spinner fa-spin" aria-hidden="true" />
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AddSro;
